/** Carti screens, the agent pages, and pages that have no site chrome. */
export function hidesAgentBubble(pathname: string): boolean {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  if (path === '/agent' || path === '/chat') return true;
  if (path === '/cartinese' || path.startsWith('/cartinese/')) return true;
  if (path === '/cartigpt' || path.startsWith('/cartigpt/')) return true;
  if (path === '/cn' || path.startsWith('/cn/')) return true;
  if (path === '/codenames' || path.startsWith('/codenames/')) return true;
  if (path === '/p' || path.startsWith('/p/')) return true;
  return false;
}
